import { css, cx } from 'emotion';
import {
	desktopMaxWidthBreakpoint,
	contentSection,
	cardSection,
	headingLarge,
	headingMedium,
	textBlock,
} from 'inside-out/global-styles';

export const titleStyle = headingLarge;

export const subTitleStyle = headingMedium;

export const textStyle = cx(
	textBlock,
	css({
		'& p': {
			maxWidth: '800px',
		},
	})
);

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	overflowX: 'hidden',
});

export const currentResearchWrapperStyle = cx(
	cardSection(60),
	css({
		marginTop: 0,
	})
);

export const contentSectionStyle = contentSection;

export const cardSectionStyle = cardSection;



// WEBPACK FOOTER //
// ./src/page-styles/project/index.js